<script>
import Rodape from '@/components/rodape.vue';
import Menu from '/src/components/header.vue';
import rodape from '@/components/rodape.vue';

export default {
    name: 'Servicos',
    components: {
        Menu,
        Rodape
    }
}
</script>

<template>
    <Menu></Menu>
    <div class="servicos">
        <div class="mainservicos">
            <p class="titulo">SERVIÇOS ESPECIALIZADOS</p>

            <p class="subtitulo1">Fabricação</p>
            <ul>
                <li class="subtitulo2">Caldeiraria:</li>
                <li>Fabricação de Estruturas Metálicas</li>
                    <li>Miscelâneas Metálicas</li>
                    <li>Moegas, Tanques, Calhas, Vasos de Pressão</li>
                    <li>Transportadores, Chutes de Descargas, Canal de Corrida, Anel de Ponte Rolante</li>
                    <li>Fabricação de Tubulações e Spools em Geral</li>
                    <li>Recuperação de Brocas, Cestos de Sucata, Distribuidores de Aço</li>
                    <li>Tampas de Panela de CDQ, Jaquetas, Caçambas, Panelas de Aço, Canaletas de Sucata</li>
                    <li>Silos, Potes, Snokel do RH, entre outros.</li>
                </ul>

                <ul>
                    <li class="subtitulo2">Usinagem:</li>
                    <li>Fabricação de peças seriadas em torno CNC e centros de usinagem</li>
                    <li>Fabricação de engrenagens, coroas, rodas dentadas, pinhões, cremalheiras de diversos módulos
                    </li>
                    <li>Serviços em eletro-erosão</li>
                    <li>Produção em grandes lotes e peças com alto nível de precisão</li>
                </ul>

            <p class="subtitulo1">Obras de Manutenção Industrial</p>
                <ul>
                    <li class="subtitulo2">Principais Serviços Realizados:</li>
                    <li>Manutenção Industrial em Regime de Parada de Fábrica nos setores de Siderurgia, Petroquímica e
                        Mineração</li>
                    <li>Manutenção de sistemas hidráulicos/pneumáticos</li>
                    <li>Montagens de Tubulações, Estruturas Metálicas</li>
                    <li>Manutenção de Caldeiras, Vasos de Pressão, Tanques e Trocadores de Calor</li>
                    <li>Manutenção de Equipamentos Estáticos e Rotativos</li>
                </ul>

            <ul>
                <li class="subtitulo2">Atividades Industriais</li>
                <div class="seps">
                    <div class="sep">
                        <li>Papel e Celulose</li>
                        <li>Mineração</li>
                        <li>Siderurgia</li>
                        </div>
                    <div class=sep>
                        <li>Energia</li>
                        <li>Alimentício</li>                              
                        <li>Portuário</li></div>
                    <div class=sep>    
                        <li>Offshore</li>
                        <li>Onshore</li>
                        <li>Petróleo e Gás</li>
                        </div>
                    </div>
            </ul>

            <p class="subtitulo1">Qualidade e Certificações</p>
            <p class="text">Cada projeto é cuidadosamente planejado para garantir a melhor solução técnica, sempre
                atendendo às
                especificações técnicas e garantindo a total satisfação dos clientes.</p>

                <ul class="gestao">
                <li class="subtitulo2">Gestão da Qualidade:</li>
                <li>Caldeiraria e Estruturas Metálicas: Normas de Inspeção e Fabricação: AWS, API e ASME</li>
                <li>Inspetor de Soldagem N1: Certificação FBTS</li>
                <li>Inspetor de Líquido Penetrante e PM: Certificação Abendi</li>
                <li>Inspetor de Ultrassom N2/N3: Certificação Abendi</li>
                <li>Inspetor Dimensional: Certificação Abendi</li>
                <li>Qualificação de Soldadores:</li>
                <ul>
                    <li>MIG/MAG – Aço Carbono e Inox</li>
                    <li>TIG GTAW – Aço Carbono e Inox</li>
                    <li>FCAW – Aço Carbono</li>
                </ul>
                <li>Documentação de Qualidade: EPS, RQPS, CQS e Procedimentos Internos de Fabricação, Inspeção,
                    Recebimento e Estocagem.</li>
            </ul>

            <ul>
                <li class="subtitulo2">Usinagem:</li>
                <li>Rastreabilidade da matéria-prima até a entrega</li>
                <li>Inspeção dimensional em todas as etapas de fabricação</li>
                <li>Sala de controle dimensional com instrumentos de medição calibrados e controlados</li>
            </ul>

            <p class="subtitulo1">Equipamentos</p>
            <ul>
                <li class="subtitulo2">Setor de Usinagem:</li>
                <div class="seps">
                    <div class="sep">
                        <ul>
                            <li>Equipamento CNC:</li>
                            <li>Centro de Usinagem – X: 2000, Y: 1200, Z: 900</li>
                            <li>Centro de Usinagem – X: 1200, Y: 850, Z: 700</li>
                            <li>Centro de Usinagem – X: 1000, Y: 700, Z: 550</li>
                            <li>Torno CNC – Diâmetro: 850, Comprimento: 2000</li>
                            <li>Eletroerosão por penetração</li>
                        </ul>
                    </div>
                    <div class="sep">
                        <ul>
                            <li>Equipamento Convencional:</li>
                            <li>Torno Convencional – Diâmetro: 850, Comprimento: 3000</li>
                            <li>Torno Convencional – Diâmetro: 850, Comprimento: 2500</li>
                            <li>Torno Convencional – Diâmetro: 750, Comprimento: 2500</li>
                            <li>Torno Mascote – Diâmetro: 420, Comprimento: 1000</li>
                            <li>Fresas Ferramenteiras</li>
                            <li>Retífica Plana</li>
                            <li>Furadeira Radial</li>
                            <li>Plaina Limadora</li>
                        </ul>
                    </div>
                </div>
            </ul>

            <ul>
                <li class="subtitulo2">Equipamentos de Movimentação de Carga:</li>
                <li>Caminhão Munck – 7 toneladas</li>
                <li>Caminhão Munck – 3 toneladas</li>
                <li>Veículos de Apoio: Fiat Strada e Renault Sandero</li>
            </ul>

            <p class="subtitulo1">Serviços de Recuperação e Montagem</p>
            <ul>
                <li class="subtitulo2">Obras Realizadas:</li>
                <li>Recuperação de estruturas de apoio no setor de armazenagem – 7 toneladas (Brasigran Ltda)</li>
                <li>Montagem de escadas de acesso, portas de emergência, mezanino em galpão logístico – 10 toneladas
                    (BTS Properties Ltda)</li>
                <li>Montagem de planta de tratamento de óleo – 8 toneladas (Coleta Ambiental)</li>
            </ul>

            <p class="subtitulo2">Equipe Qualificada:</p>
            <p class="text">Nossa equipe é treinada para garantir segurança, qualidade e pontualidade em todos os
                projetos.</p>
        </div>
    </div>
    <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.servicos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    min-height: 53.5vh;
}

.mainservicos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    text-align: center;
}

.menu {
    position: relative;
    width: 100%;
    z-index: 1;
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0;
    color: #2e74c4;
}

.subtitulo1 {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0;
    color: #444;
}

.subtitulo2 {
    font-size: 1.1rem;
    font-weight: bold;
    margin: 1.5rem 0;
    color: #444;
}

.text2 {
    text-align: left;
    width: 100%;
    font-size: 1rem;
    color: #444;
    line-height: 1.5rem;
}

.text {
    text-align: center;
    width: 95%;
    font-size: 1.2rem;
    letter-spacing: 2px;
    color: #444;
    line-height: 2rem;
    margin-bottom: 1rem;
    background-color: #44444417;
    border-radius: 5px;
}

.gestao {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 2rem;
}

.bloco1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style-type: none;
    margin-bottom: 1rem;
    width: 95%;
    padding: 0rem;
}

.seps {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.sep {
    width: 95%;
}

ul {
    padding-left: 0;
    list-style-type: none;
    width: 95%;
    margin-bottom: 2rem;
}

li {
    text-align: left;
    color: #444;
    line-height: 1.5rem;
}
}
@media (min-width: 901px) {
.servicos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    min-height: 53.5vh;
}

.mainservicos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    text-align: center;
}

.menu {
    position: relative;
    width: 100%;
    z-index: 1;
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0;
    color: #2e74c4;
}

.subtitulo1 {
    font-size: 1.3rem;
    font-weight: bold;
    margin: 1rem 0;
    color: #444;
}

.subtitulo2 {
    font-size: 1.1rem;
    font-weight: bold;
    margin: 1.5rem 0;
    color: #444;
}

.text2 {
    text-align: left;
    width: 100%;
    font-size: 1rem;
    color: #444;
    line-height: 1.5rem;
}

.text {
    text-align: center;
    width: 90%;
    font-size: 1.2rem;
    letter-spacing: 2px;
    color: #444;
    line-height: 2rem;
    margin-bottom: 1rem;
    background-color: #44444417;
    border-radius: 5px;
    margin-bottom: 1rem;
}

.gestao {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 2rem;
}

.bloco1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style-type: none;
    margin-bottom: 1rem;
    width: 95%;
    padding: 1rem;
}

.seps {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.sep {
    width: 80%;
}

ul {
    padding-left: 0;
    list-style-type: none;
    width: 70%;
    margin-bottom: 2rem;
}

li {
    text-align: left;
    color: #444;
    line-height: 1.5rem;
}
}
</style>
